var AdaptiveImage = require( "../../../node_modules/react-native-web-image-loader/lib/modules/adaptiveImage.js" );

module.exports = new AdaptiveImage({
    uri: __webpack_public_path__ + "a1774f59b4f180b50ccc620aaa0f382d.png",
    width: 1172,
    height: 225
});